import React, { useContext, useEffect, useState } from 'react'
//import Filter from '../cmp/Filter'
import icon from '../icons.svg'
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import { dataContext, localestr, toText, isValidDate, load, units } from '../utils.js'
//import Checker from '../cmp/Checker.js'
import EditCtrl from '../cmp/EditCtrl.js'

let loading = false

function RepSysBASE({ actions, setModal, buttons }) {
  const context = useContext(dataContext)
  const { getWndData = () => ({}), setWndData = () => { } } = actions || {};
  const wndData = getWndData();

  const [backendData, setBackendData] = useState(wndData.backendData || { supply: [], orders: [] });
  const [arrGoodType, setArrGoodType] = useState(wndData.arrGoodType || { sale: '1', supply: '1' });
  const [arrDep, setArrDep] = useState(wndData.arrDep ||
    (context.data.catDevices || [])
      .map(el => (Number(el.device) === 4 || Number(el.device) === 5) ? [el.id, '1'] : null)
      .filter(Boolean)
  );


  const setSettings = context.setSettings
  const Data = context.data.catDevices
  const getData = context.getData
  const msg = context.msg
  const inputRange = context.inputRange

  useEffect(() => {
    if (!Data) getData('catDevices')
    // eslint-disable-next-line 
  }, [Data])


  let from = wndData.from instanceof Date ? wndData.from : (() => { const d = new Date(); d.setHours(0, 0, 0, 0); return d; })()
  let to = wndData.to instanceof Date ? wndData.to : (() => { const d = new Date(); d.setHours(23, 59, 59, 999); return d; })()
  function range(frm, to_) {
    let froml = from
    let tol = to
    if (isValidDate(frm)) froml = frm
    if (isValidDate(to_)) tol = to_
    if (froml > tol) {
      msg(localestr('Не правильний діапазон дат'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
      return
    }
    setWndData({ ...wndData, from: froml, to: tol })
    setSettings({ repStock: { from: froml, to: tol, grouping } })
  }

  let grouping = [{ name: localestr('Товар'), value: 'good_id', checked: true, type: 'catGoods' },
  { name: localestr('Група'), value: 'folder_id', checked: false, type: 'fldGoods' },
  { name: localestr('Підрозділ'), value: 'department_id', checked: false, type: 'catDepartments' },
  { name: localestr('Тип товару'), value: 'g_type', checked: false, type: 'selGoodType' },
  { name: localestr('Документ'), value: 'doc_id', checked: false, type: 'document' },
  { name: localestr('Куди-Звідки'), value: 'from_to', checked: false, type: 'catalog', disable_move: true }]

  const handleExport = (d) => {
    if (!d) {
      if (loading) return;
      loading = true;
      setTimeout(() => { loading = false }, 2000);
      const formatDateTime = (dateVal, isEndOfDay = false) => {
        const dateObj = dateVal instanceof Date ? dateVal : new Date(dateVal);
        if (isNaN(dateObj.getTime())) return '';
        const y = dateObj.getFullYear();
        const m = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        const timePart = isEndOfDay ? '23:59:59' : '00:00:00';
        return `${y}-${m}-${day} ${timePart}`;
      };
      const selectedFiscalIds = Object.entries(arrDep)
        .filter(([_, value]) => value === '1')
        .map(([id]) => ({ id: id }));
      const requestData = {
        from: formatDateTime(wndData.from || from, false),
        to: formatDateTime(wndData.to || to, true),
        fiscal: selectedFiscalIds,
        supply: arrGoodType.supply === '1',
        orders: arrGoodType.sale === '1'
      };
      const queryString = `action=exporData&data=${encodeURIComponent(JSON.stringify(requestData))}`;
      load(queryString, handleExport);
    }
    else if (d) {
      const status = d.status;
      if (status === 'OffLine') {
        msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]);
        return;
      }
      if (status === 'error') {
        msg(d.msg || localestr('Помилка отримання даних'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]);
        return;
      }
      const newBackData = {
        supply: d.supply || [],
        orders: d.orders || []
      }
      setBackendData(newBackData)
      setWndData({ ...wndData, backendData: newBackData });
    }
  };

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div>
        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row' }}>
          <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div className='toolBar no-print' style={{ padding: '5px 0' }}>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                {localestr('За період:')}
                <div tabIndex='0' onClick={() => { inputRange(from, to, range) }} onKeyUp={(e) => { if (e.key === 'Enter') range() }}
                  style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '205px', padding: '0px 2px 0 6px', userSelect: 'none', cursor: 'pointer', color: '#FFF', background: 'url(' + icon + '#btn185v) no-repeat', backgroundSize: '200px 30px' }}>
                  {toText(from)}-{toText(to)}
                  <img style={{ width: '24px', height: '24px', verticalAlign: 'middle' }} src={icon + '#cal_w'} alt={localestr('Інтервал дат')} />
                </div>
              </div>

              <div tabIndex='0' onClick={() => { handleExport() }} onKeyUp={(e) => { if (e.key === 'Enter') handleExport() }}
                style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
                <img style={{ width: '12px', height: '24px', padding: '2px', verticalAlign: 'middle' }} src={icon + '#run'} alt={localestr('Вивести')} />&nbsp;
                {localestr('Вивести')}
              </div>
            </div>
          </div>
          <div className='reportTuns no-print' style={{ display: 'flex', flexDirection: 'column', gap: '15px', padding: '10px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              {localestr('Фіскальні реєстратори:')}
              <div style={{ paddingLeft: '20px', marginTop: '5px', maxWidth: '120px' }}>
                {context.data.catDevices?.map(el => (Number(el.device) === 4 || Number(el.device) === 5) && (
                  <EditCtrl
                    key={el.id}
                    Capt={el.name}
                    title={el.name}
                    Value={arrDep[el.id]}
                    typeVal="l_check"
                    setVal={(val) => {
                      const updatedDep = { ...arrDep, [el.id]: val };
                      setArrDep(updatedDep);
                      setWndData({ ...wndData, arrDep: updatedDep });
                    }}
                  />
                ))}
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              {localestr('Типи операцій:')}
              <div style={{ paddingLeft: '20px', marginTop: '5px', maxWidth: '120px' }}>
                <div>
                  <EditCtrl
                    Capt={'Прихід'}
                    title={'Прихід'}
                    Value={arrGoodType.supply}
                    typeVal={'l_check'}
                    setVal={(val) => {
                      const updatedGood = { ...arrGoodType, supply: val };
                      setArrGoodType(updatedGood);
                      setWndData({ ...wndData, arrGoodType: updatedGood })
                    }}
                    width1={120}
                    width2={24}
                  />
                </div>
                <div>
                  <EditCtrl
                    Capt="Продаж"
                    title="Продаж"
                    Value={arrGoodType.sale}
                    typeVal="l_check"
                    setVal={(val) => {
                      const updatedGood = { ...arrGoodType, sale: val };
                      setArrGoodType(updatedGood);
                      setWndData({ ...wndData, arrGoodType: updatedGood })
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {(backendData.supply.length > 0 || backendData.orders.length > 0) && (
        <div style={{ width: 'calc(100% - 200px)', position: 'absolute', top: '40px', height: '100%' }}>
          {tableData(backendData)}
        </div>
      )}
    </div>
  )
}

export default RepSysBASE


const tableData = (d) => {
  const { supply, orders } = d;
  const supplyData = supply.map(item => ({ ...item, type: 'supply' }));
  const ordersData = orders.map(item => ({ ...item, type: 'orders' }));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', padding: '5px', background: '#fff' }}>
      <div className='no-print' style={{ display: 'flex', justifyContent: 'end', paddingTop: '10px', paddingRight: '10px' }}>
        <img style={{ cursor: 'pointer', width: '24px', height: '24px' }} src={icon + '#xlsx'} alt='' onClick={() => exportExcel(d)} />
      </div>
      {supplyData.length > 0 && (
        <div >
          <h4 style={{ textAlign: 'center', margin: '0 0 10px 0' }}>Поступлення</h4>

          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#fff' }}>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('№')}</th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('Дата')}</th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('ID')} <br /> {localestr('товару')} </th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('Назва товару')}</th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('ID')} <br /> {localestr('контрагента')} </th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('Назва')} <br /> {localestr('контрагента')} </th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('Фіскальний')} <br /> {localestr('реєстратор')}</th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('ЄДРПОУ')}</th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('Кількість')}</th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('Од.')}</th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('Сума')}</th>
              </tr>
            </thead>
            <tbody>
              {supplyData.sort((a, b) => b.date - a.date).map((item, index) => (
                <tr key={`supply-${index}`} style={{ backgroundColor: '#fff', borderBottom: '1px solid #chchch' }}>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{index + 1}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{item.date?.replace(/-/g, '.')}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{item.good_id}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{item.good}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{item.counterpartie_id}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{item.counterpartie}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{item.fiscal}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{item.okpo}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{item.qtt}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{units[item.unit]}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{item.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div >
      )}

      {ordersData.length > 0 && (
        <div>
          <h4 style={{ textAlign: 'center', margin: '0 0 10px 0' }}>Продажі</h4>

          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#fff' }}>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('№')}</th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('Дата')}</th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('ID')} <br /> {localestr('товару')} </th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('Назва товару')}</th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('Фіскальний')} <br /> {localestr('реєстратор')}</th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('Кількість')}</th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('Од.')}</th>
                <th style={{ padding: '2px', fontSize: '14px', border: '1px solid #000' }}>{localestr('Сума')}</th>
              </tr>
            </thead>
            <tbody>
              {ordersData.sort((a, b) => b.date - a.date).map((item, index) => (
                <tr key={`orders-${index}`} style={{ backgroundColor: '#fff', border: '1px solid #000' }}>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{index + 1}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{item.date?.replace(/-/g, '.')}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{item.good_id}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{item.good}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{item.fiscal}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{item.qtt}</td>
                  <td style={{ padding: '2px', textAlign: 'center', border: '1px solid #000' }}>{units[item.unit]}</td>
                  <td style={{ padding: '2px', textAlign: 'center' }}>{item.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div >
      )}
    </div>
  )
}

const exportExcel = async (data) => {
  if (!data) return;
  const { supply, orders } = data;
  const workbook = new ExcelJS.Workbook();
  const sheet = supply.length > 0 ? workbook.addWorksheet('Поступлення') : null;
  const sheet2 = orders.length > 0 ? workbook.addWorksheet('Продажі') : null;

  if (supply.length > 0) {
    sheet.addRow(['№', 'Дата', 'ID товару', 'Назва товару', 'ID контрагента', 'Назва контрагента', 'Фіскальний реєстратор', 'ЄДРПОУ', 'Кількість', 'Од.', 'Сума']);

    const rows = supply.map((item, index) => [
      index + 1,
      item.date ? item.date.replace(/-/g, '.') : '',
      item.good_id,
      item.good,
      item.counterpartie_id,
      item.counterpartie,
      item.fiscal,
      item.okpo,
      Number(item.qtt) || 0,
      units[item.unit],
      Number(item.amount) || 0
    ]);
    sheet.addRows(rows);
    sheet.getRow(1).font = { bold: true };
    sheet.columns.forEach((col, i) => {
      if (i === 0) col.width = 6;
      else if (i === 3) col.width = 40;
      else col.width = 18;
    });
  }

  if (orders.length > 0) {
    sheet2.addRow(['№', 'Дата', 'ID товару', 'Назва товару', 'Фіскальний реєстратор', 'Кількість', 'Од.', 'Сума']);

    const rows2 = orders.map((item, index) => [
      index + 1,
      item.date ? item.date.replace(/-/g, '.') : '',
      item.good_id,
      item.good,
      item.fiscal,
      Number(item.qtt) || 0,
      units[item.unit],
      Number(item.amount) || 0
    ]);

    sheet2.addRows(rows2);
    sheet2.getRow(1).font = { bold: true };
    sheet2.columns.forEach((col, i) => {
      if (i === 0) col.width = 6;
      else if (i === 3) col.width = 40;
      else col.width = 18;
    });
  } else {
    return;
  }

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), "report.xlsx");
};